(function () {
  const root = document.querySelector('#product-reviews');
  if (!root) return;

  const SHOW_LIMIT = parseInt(root.dataset.showLimit || '4', 10);
  const BATCH = 4;

  const FORM_INPUTS = {
    purchase_format: '#ml-review-format',
    recommended_season: '#ml-review-season',
    recommended_time: '#ml-review-time',
    longevity: '#ml-review-longevity',
    sillage: '#ml-review-sillage',
    scent_direction: '#ml-review-scent-direction'
  };

  /* ===== Relative Zeit ===== */
  function renderWeeksMonths(node) {
    const dtAttr = node.getAttribute('datetime');
    if (!dtAttr) return;
    const then = new Date(dtAttr).getTime();
    if (Number.isNaN(then)) return;
    const diffDays = Math.max(0, Math.floor((Date.now() - then) / 86400000));
    if (diffDays === 0) node.textContent = 'heute';
    else if (diffDays < 14) node.textContent = `vor ${diffDays} ${diffDays === 1 ? 'Tag' : 'Tagen'}`;
    else {
      const weeks = Math.floor(diffDays / 7);
      node.textContent = `vor ${weeks} ${weeks === 1 ? 'Woche' : 'Wochen'}`;
    }
  }

  root.querySelectorAll('.js-rel-time-wm').forEach(renderWeeksMonths);
  setInterval(() => root.querySelectorAll('.js-rel-time-wm').forEach(renderWeeksMonths), 12 * 60 * 60 * 1000);

  /* ===== Badge helpers ===== */
  function activateBadge(group, activeBtn) {
    group.querySelectorAll('.reviews-badge').forEach((btn) => {
      const on = btn === activeBtn;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ===== Scent / identity filter ===== */
  const list = root.querySelector('.review-list');
  const scentGroup = root.querySelector('.reviews-scent__chips');
  const scentBlock = root.querySelector('.reviews-scent');
  const scentStatus = root.querySelector('[data-scent-status]');
  const emptyFiltered = root.querySelector('[data-review-filter-empty]');
  const moreBtn = root.querySelector('[data-more]');
  const moreFooter = root.querySelector('.reviews-footer');
  const PRIMARY_SCENTS = new Set(['frische_zitrus_duefte', 'fruchtige_duefte', 'aquatische_duefte']);

  let activeScent = null;

  function getItems() {
    return list ? Array.from(list.querySelectorAll('.review')) : [];
  }

  function reviewTotalCount() {
    const fromData = parseInt(scentBlock?.dataset.reviewTotal || '0', 10);
    return fromData || getItems().length;
  }

  function sortNewest(items) {
    return [...items].sort((a, b) => parseInt(b.dataset.ts || '0', 10) - parseInt(a.dataset.ts || '0', 10));
  }

  function matchesScent(item) {
    if (!activeScent) return true;
    const dir = item.dataset.scentDirection || '';
    if (activeScent === 'other') {
      return dir !== '' && !PRIMARY_SCENTS.has(dir);
    }
    return dir === activeScent;
  }

  function updateStatus(matchedCount) {
    if (!scentStatus) return;
    const total = reviewTotalCount();
    if (!activeScent) {
      scentStatus.textContent = `Alle ${total} Bewertungen werden angezeigt`;
    } else {
      scentStatus.textContent = `${matchedCount} von ${total} Bewertungen`;
    }
  }

  function applyView() {
    if (!list) return;
    const items = sortNewest(getItems());
    const matched = items.filter(matchesScent);

    items.forEach((el) => list.appendChild(el));

    let visibleCount = 0;
    items.forEach((el) => {
      const show = matchesScent(el);
      el.classList.toggle('is-filtered-out', !show);
      if (show) {
        visibleCount += 1;
        el.classList.toggle('is-hidden', visibleCount > SHOW_LIMIT);
      } else {
        el.classList.add('is-hidden');
      }
    });

    updateStatus(matched.length);

    if (emptyFiltered) {
      emptyFiltered.hidden = matched.length > 0;
    }
    if (moreFooter) {
      const hiddenVisible = matched.filter((el) => el.classList.contains('is-hidden') && !el.classList.contains('is-filtered-out'));
      moreFooter.style.display = hiddenVisible.length > 0 ? '' : 'none';
    }
  }

  scentGroup?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scent-filter]');
    if (!btn || !scentGroup.contains(btn)) return;
    const value = btn.getAttribute('data-scent-filter');
    if (activeScent === value) {
      activeScent = null;
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    } else {
      activeScent = value;
      scentGroup.querySelectorAll('[data-scent-filter]').forEach((chip) => {
        const on = chip === btn;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    applyView();
  });

  moreBtn?.addEventListener('click', () => {
    const hidden = getItems().filter((el) => el.classList.contains('is-hidden') && !el.classList.contains('is-filtered-out'));
    hidden.slice(0, BATCH).forEach((el) => el.classList.remove('is-hidden'));
    if (hidden.length <= BATCH && moreFooter) moreFooter.style.display = 'none';
  });

  applyView();

  /* ===== Review Form ===== */
  const formPanel = root.querySelector('#review-form-panel');
  const form = root.querySelector('#ml-review-form');
  const toggleBtn = root.querySelector('[data-review-form-toggle]');
  const cancelBtn = root.querySelector('[data-review-form-cancel]');
  const ratingInput = root.querySelector('#ml-review-rating');
  const starBtns = root.querySelectorAll('.reviews-form__star');
  const successEl = root.querySelector('[data-review-form-success]');
  const errorEl = root.querySelector('[data-review-form-error]');
  const configEl = document.getElementById('ml-review-form-config');

  let config = {};
  try { config = JSON.parse(configEl?.textContent || '{}'); } catch (_) {}

  toggleBtn?.addEventListener('click', () => {
    formPanel.hidden = !formPanel.hidden;
    toggleBtn.setAttribute('aria-expanded', formPanel.hidden ? 'false' : 'true');
    if (!formPanel.hidden) formPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  cancelBtn?.addEventListener('click', () => {
    formPanel.hidden = true;
    toggleBtn.setAttribute('aria-expanded', 'false');
  });

  starBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const val = parseInt(btn.dataset.star, 10);
      ratingInput.value = String(val);
      starBtns.forEach((s, i) => {
        s.textContent = i < val ? '★' : '☆';
        s.classList.toggle('is-active', i < val);
      });
      root.querySelector('[data-error-for="rating"]').hidden = true;
    });
  });

  root.querySelectorAll('[data-form-badge]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const field = btn.dataset.formBadge;
      const value = btn.dataset.value;
      const input = root.querySelector(FORM_INPUTS[field]);
      const group = btn.closest('.reviews-form__badges');
      if (!input || !group) return;

      input.value = value;
      activateBadge(group, btn);
      const err = root.querySelector(`[data-error-for="${field}"]`);
      if (err) err.hidden = true;
    });
  });

  function resetFormBadges() {
    root.querySelectorAll('.reviews-form__badges').forEach((group) => {
      group.querySelectorAll('.reviews-badge').forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
    });
  }

  function timeLabel(v) {
    return ({ tag: 'Tag', nacht: 'Nacht', beides: 'Tag & Nacht' })[v] || v;
  }
  function seasonLabel(v) {
    return ({
      fruehling: 'Frühling',
      sommer: 'Sommer',
      herbst: 'Herbst',
      winter: 'Winter',
      ganzjahrig: 'Ganzjährig'
    })[v] || v;
  }
  function formatLabel(v) {
    return ({ tester_kit: 'Discovery Kit (3ml)', flakon_50ml: '50ml Flakon' })[v] || v;
  }
  function longevityLabel(v) {
    return ({ '2_4h': '2–4h', '4_8h': '4–8h', '8h_plus': '8h+' })[v] || v;
  }
  function sillageLabel(v) {
    return ({
      dezent: 'dezent',
      moderat: 'moderat',
      bemerkbar: 'bemerkbar',
      raumfuellend: 'raumfüllend'
    })[v] || v;
  }
  function scentDirectionLabel(v) {
    return ({
      vanilledufte: 'Vanilledüfte',
      ledrige_duefte: 'Ledrige Düfte',
      blumige_duefte: 'Blumige Düfte',
      fruchtige_duefte: 'Fruchtige Düfte',
      gourmand_duefte: 'Gourmand-Düfte',
      holzige_oud_duefte: 'Holzige/Oud-Düfte',
      frische_zitrus_duefte: 'Frische/Zitrus-Düfte',
      wuerzige_duefte: 'Würzige Düfte',
      aquatische_duefte: 'Aquatische Düfte',
      pudrige_duefte: 'Pudrige Düfte'
    })[v] || v;
  }

  async function submitViaContact(data) {
    const body = [
      'Neue Produktbewertung (Freigabe ausstehend)',
      `Produkt: ${data.product_title} (${data.product_handle})`,
      `Sterne: ${data.rating}/5`,
      `Name: ${data.author_name}`,
      `Ort: ${data.author_location1 || '—'}`,
      `Getestet als: ${formatLabel(data.purchase_format)}`,
      `Passt zu: ${seasonLabel(data.recommended_season)}`,
      `Tageszeit: ${timeLabel(data.recommended_time)}`,
      `Haltbarkeit: ${longevityLabel(data.longevity)}`,
      `Sillage: ${sillageLabel(data.sillage)}`,
      `Sonst eher: ${scentDirectionLabel(data.scent_direction)}`,
      `Überschrift: ${data.title || '—'}`,
      `Empfiehlt: ${data.recommends ? 'Ja' : 'Nein'}`,
      '',
      data.body
    ].join('\n');

    const fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', data.email);
    fd.append('contact[name]', data.author_name);
    fd.append('contact[body]', body);

    const res = await fetch('/contact', { method: 'POST', body: fd, headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error('Senden fehlgeschlagen');
  }

  async function submitViaEndpoint(data) {
    const res = await fetch(config.submitEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Senden fehlgeschlagen');
  }

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;

    const requiredFields = [
      { input: ratingInput, key: 'rating' },
      { input: root.querySelector('#ml-review-format'), key: 'purchase_format' },
      { input: root.querySelector('#ml-review-season'), key: 'recommended_season' },
      { input: root.querySelector('#ml-review-time'), key: 'recommended_time' },
      { input: root.querySelector('#ml-review-longevity'), key: 'longevity' },
      { input: root.querySelector('#ml-review-sillage'), key: 'sillage' },
      { input: root.querySelector('#ml-review-scent-direction'), key: 'scent_direction' }
    ];

    let valid = true;
    requiredFields.forEach(({ input, key }) => {
      const err = root.querySelector(`[data-error-for="${key}"]`);
      if (!input?.value) {
        if (err) err.hidden = false;
        valid = false;
      } else if (err) {
        err.hidden = true;
      }
    });
    if (!valid) return;

    const fd = new FormData(form);
    const data = {
      product_id: fd.get('product_id'),
      product_handle: fd.get('product_handle'),
      product_title: fd.get('product_title'),
      rating: parseInt(ratingInput.value, 10),
      author_name: fd.get('author_name'),
      author_location1: fd.get('author_location1') || '',
      purchase_format: requiredFields[1].input.value,
      recommended_season: requiredFields[2].input.value,
      recommended_time: requiredFields[3].input.value,
      longevity: requiredFields[4].input.value,
      sillage: requiredFields[5].input.value,
      scent_direction: requiredFields[6].input.value,
      title: fd.get('title') || '',
      body: fd.get('body'),
      recommends: fd.get('recommends') === 'true',
      email: fd.get('email')
    };

    const submitBtn = form.querySelector('.reviews-form__submit');
    submitBtn.disabled = true;

    try {
      if (config.submitEndpoint) await submitViaEndpoint(data);
      else await submitViaContact(data);
      form.reset();
      ratingInput.value = '';
      requiredFields.slice(1).forEach(({ input }) => { if (input) input.value = ''; });
      starBtns.forEach((s) => { s.textContent = '☆'; s.classList.remove('is-active'); });
      resetFormBadges();
      successEl.hidden = false;
      form.querySelector('.reviews-form__actions').hidden = true;
    } catch (err) {
      errorEl.textContent = 'Leider ist etwas schiefgelaufen. Bitte versuche es später erneut.';
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
    }
  });
})();

/* identity-filter-v15 */
